<script lang="ts" setup>
    import { ref, nextTick } from "vue";
    import { ITimelineTelemedicine, ITimelineSectionClick, TimelineSection } from "../lib/Models/EMR/TimelineModel";
    import { NoTzDate } from '../lib/DateUtils';

    defineExpose({buildDisplay});
    const emit = defineEmits<{
        (e: "displayBuiltSection", strValue: ITimelineSectionClick): void
    }>(); 

    const telemedicineDisplay = ref<ITimelineTelemedicine[]>();

    function buildDisplay(telemedicineList: ITimelineTelemedicine[], date: NoTzDate) {
        telemedicineDisplay.value = telemedicineList.filter(item => item.encounterDate === date);
        nextTick(() => { 
            const element = document.getElementById("telemedicineDisplayHtml");
            if (!element)
                return;
            const timelineSectionClick: ITimelineSectionClick =  {
                id: TimelineSection.Telemedicine,
                date: date,
                html: element.innerHTML
            }
            emit("displayBuiltSection", timelineSectionClick);
        }); 
    }

</script>

<template>
    <div id="telemedicineDisplayHtml">
        <div v-for="item in telemedicineDisplay">
            <span class="header-obstetrics-width">Message Sent:</span><span>{{item.sendMessageDate}}</span><br />
            <span class="header-obstetrics-width">Patient Connected:</span><span>{{item.patientSessionDate}}</span><br />
            <span class="header-obstetrics-width">Provider Connected:</span><span>{{item.startSessionDate}}</span><br />
            <span class="header-obstetrics-width">Completed:</span><span>{{item.endSessionDate}}</span><br />
            <span class="header-obstetrics-width">Instructions:</span><span>{{item.postVisitInstructions ?? ""}}</span><br />
            <span>&nbsp;</span><br />
        </div>
    </div>
</template>
